import { API, Auth } from 'aws-amplify';

import {
  createAiClientQualification,
  updateAiClientQualification,
  deleteAiClientQualification,
  createAiClientQualificationDocument,
  deleteAiClientQualificationDocument,
} from '../../../../graphql/customMutations';
import { getAiClientQualification } from '../../../../graphql/customQueries';
import checklistApi from '../../../../utils/checklistAPI';

export const getQualification = async id => {
  try {
    const response = await API.graphql({ query: getAiClientQualification, variables: { id } });
    return response.data?.getAiClientQualification;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return e;
  }
};

export const createQualification = async input => {
  try {
    const response = await API.graphql({ query: createAiClientQualification, variables: { input } });
    return response.data?.createAiClientQualification;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return { errors: e };
  }
};

export const updateQualification = async input => {
  try {
    const response = await API.graphql({ query: updateAiClientQualification, variables: { input } });
    return response.data?.updateAiClientQualification;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return { errors: e };
  }
};

export const removeQualification = async id => {
  try {
    const response = await API.graphql({ query: deleteAiClientQualification, variables: { input: { id } } });
    return response;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return e;
  }
};

export const createQualificationDocument = async input => {
  try {
    const response = await API.graphql({ query: createAiClientQualificationDocument, variables: { input } });
    return response.data?.createAiClientQualificationDocument;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return { errors: e };
  }
};

export const removeQualificationDocument = async id => {
  try {
    const response = await API.graphql({ query: deleteAiClientQualificationDocument, variables: { input: { id } } });
    return response;
  } catch (e) {
    console.log(`Error: ${JSON.stringify(e)}`);
    return e;
  }
};

// REST lookups (dqf-apiv2), same endpoints the Checklist form uses.
export const getClient = async id => {
  try {
    return await API.get('centerlineportal', `clients/${id}`);
  } catch (e) {
    return e;
  }
};

export const getAMC = async code => {
  try {
    return await API.get('centerlineportal', `amc/${code}`);
  } catch (e) {
    return e;
  }
};

// "Evaluate Documents" ingestion/recognition check (mockup page 26).
// NOTE: the /dqf-qual-evaluate endpoint is a required backend addition — the ingestion check is an
// OPEN item in the DQF AI decisions log (how qual docs are validated). Until it ships this rejects,
// and the UI shows the failure modal.
export const evaluateDocuments = async id => {
  const token = (await Auth.currentSession()).getIdToken().getJwtToken();
  const response = await checklistApi.post('/dqf-qual-evaluate', { id }, { headers: { Authorization: token } });
  return response.data;
};
